import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';
import { uploadToAws } from '../ContentInformation/uploadToAws';
import { RouterInput } from '../../../../lib/trpc';

export default function useUploadPropertyTemplateDocument() {
    return useMutation(
        async ({
            file,
            propertyId,
            documentType,
            documentSubtype,
            name,
        }: {
            file: File;
            propertyId: number;
            documentType: Required<RouterInput['TemplatesApi']['uploadPropertyTemplateDocument']['documentType']>;
            documentSubtype: RouterInput['TemplatesApi']['uploadPropertyTemplateDocument']['documentSubtype'];
            name: string;
        }) => {
            const fileToSave = {
                name: name ?? file.name,
                size: file.size,
                type: file.type,
            };

            const response = await trpc.TemplatesApi.uploadPropertyTemplateDocument.mutate({
                file: fileToSave,
                propertyId,
                documentType,
                documentSubtype,
            });

            if (response) {
                await uploadToAws({
                    preSingedUrl: response.preSingedUrl,
                    file,
                    cleanup: async () => {
                        await trpc.TemplatesApi.removePropertyTemplateDocument.mutate({
                            id: response.id,
                            propertyId,
                        });
                    },
                });
            }
            return response;
        },
    );
}
